import React, { useEffect, useState } from "react";
import {
    Backdrop,
    Button,
    CircularProgress,
    Grid,
    TablePagination,
    TextField,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import "../../tag_status.css"
// components
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from '@material-ui/icons/Check';
import MessageIcon from '@material-ui/icons/Message';
import PageTitle from "../../components/PageTitle";
import GetAppIcon from "@material-ui/icons/GetApp";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import Notification from "../../components/Notification";
// data
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CustomPdfView from "../../components/pdfViewer/CustomPdfView.js";
import { getFileExtension } from "../../utils/getextension.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const positions = [toast.POSITION.TOP_RIGHT];
export default function AdminInvoiceHistory() {

    const classes = useStyles();
    const mobileQuery = useMediaQuery('(max-width:600px)');
    const token = localStorage.getItem("token");
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [requirementsData, setRequirementsData] = useState([]);

    const [page, setPage] = useState(0);
    const [currerntPage, setCurrerntPage] = useState(1);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [transferopen, setTransferOpen] = React.useState(false);
    const [reasonOpen, setReasonOpen] = React.useState(false);
    const [invoicePDF, setInvoicePDF] = React.useState("");
    const [rejectReason, setRejectReason] = React.useState("");
    const [transactionStatus, setTransactionStatus] = React.useState({
        paid: false,
        reject: false
    })

    const [paymentId, setPaymentId] = React.useState("");
    const [transactionPaidNumber, setTransactionPaidNumber] = React.useState("");
    const [transactionRejectReason, setTransactionRejectReason] = React.useState("");

    var [errorToastId, setErrorToastId] = useState(null);

    function sendNotification(componentProps, options) {
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options,
        );
    }

    function handleNotificationCall(notificationType, message) {
        var componentProps;

        if (errorToastId && notificationType === "error") return;

        switch (notificationType) {
            case "info":
                componentProps = {
                    type: "feedback",
                    message: message,
                    variant: "contained",
                    color: "primary",
                };
                break;
            case "error":
                componentProps = {
                    type: "message",
                    message: message,
                    variant: "contained",
                    color: "secondary",
                };
                break;
            default:
                componentProps = {
                    type: "shipped",
                    message: message,
                    variant: "contained",
                    color: "success",
                };
        }

        var toastId = sendNotification(componentProps, {
            type: notificationType,
            position: positions[2],
            progressClassName: classes.progress,
            onClose: notificationType === "error" && (() => setErrorToastId(null)),
            className: classes.notification,
        });

        if (notificationType === "error") setErrorToastId(toastId);
    }

    const invoiceUrl = invoicePDF;
    const fileExtension = invoiceUrl ? getFileExtension(invoiceUrl) : null;

    const handleModalClose = () => {
        setModalOpen(false);
    };
    const handleModalOpen = (invoice) => {
        setModalOpen(true);
        setInvoicePDF(invoice)
    };

    const updateTransactionOpen = (invoiceId) => {
        setTransferOpen(true);
        setPaymentId(invoiceId)
    };
    const updateTransactionClose = () => {
        setTransferOpen(false);
        setTransactionStatus({
            paid: false,
            reject: false
        })
    };

    const rejectInvoiceByAdmin = async () => {
        if (transactionRejectReason === "") {
            handleNotificationCall("error", "Transaction reject reason is required");
            return
        }
        setLoader(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/rejectInvoice`,
            data: {
                id: paymentId,
                reason: transactionRejectReason
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {

            if (response.data.status === true) {
                setLoader(false);
                handleNotificationCall("success", response.data.message);
                fetchData();
                updateTransactionClose();
            } else {
                handleNotificationCall("error", response.data.message);
                setLoader(false);
            }
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        })
    };

    const approveInvoiceByAdmin = async () => {
        if (transactionPaidNumber === "") {
            handleNotificationCall("error", "Transaction number is required");
            return
        }
        setLoader(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/confirmTransfer`,
            data: {
                id: paymentId,
                transactionNumber: transactionPaidNumber
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {

            if (response.data.status === true) {
                setLoader(false);
                handleNotificationCall("success", response.data.message);
                fetchData()
                updateTransactionClose()

            } else {
                handleNotificationCall("error", response.data.message);
                setLoader(false);
            }
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        })
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoader(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/adminViewAllRedemption`,
            data: {
                page: 1,
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {

            if (response.data.status === true) {
                setLoader(false);
                setRequirementsData(response.data.data);
                setCount(response.data.count);
            }
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        })
    };

    function getApprovalStatusColor(status) {
        let className;
        switch (status) {
            case "PENDING":
                className = "neutral-extrahigh"
                break;
            case "PAID":
                className = "positive-medium"
                break;
            case "REJECTED":
                className = "critical-low"
                break;
            default:
                className = "neutral-extrahigh"
                break;
        }
        return className;
    }

    const blinkIteration = {
        "--iteration-count": "infinite",
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setCurrerntPage(newPage + 1);
        setLoader(true);

        var data = JSON.stringify({
            page: newPage + 1,
        });

        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}recruiter/myAssignedRequirements`,
            data: data,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {
            if (response.data.status === true) {
                setRequirementsData(response.data.data);
                setCount(response.data.count);
                setLoader(false);
            }

            setLoader(false);
        });
    };



    const [state, setState] = useState({
        right: false,
    });

    const HeaderElements = () => (
        <>
            <Grid className={classes.HeaderElements}>
                Total : {count}
            </Grid>
        </>
    );

    return (
        <>
            <Grid container direction="row" spacing={2} className={classes.heading}>
                <Grid item xs={9} sm={7} md={8} lg={6}>
                    <PageTitle title="Freelancer Invoice" />
                </Grid>

                <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>

                    {/* <SwipeableDrawer
                        anchor="right"
                        open={state["right"]}
                        onClose={toggleDrawer("right", false)}
                        onOpen={toggleDrawer("right", true)}
                        classes={{ paper: classes.drawer }}
                    >
                    </SwipeableDrawer> */}
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MUIDataTable
                        title=""
                        options={{
                            pagination: false,
                            sort: false,
                            selectableRows: "none",
                            search: false,
                            filter: false,
                            download: false,
                            print: false,
                            customToolbar: () => <HeaderElements />,
                            responsive: mobileQuery === true ? 'vertical' : 'standard',
                            textLabels: {
                                body: {
                                    noMatch: 'Oops! Matching record could not be found',
                                }
                            },
                        }}
                        columns={[
                            {
                                name: "S.No",
                            },
                            {
                                name: "Freelancer Name",
                            },
                            {
                                name: "Inoice ID",
                            },
                            {
                                name: "Transaction Number",
                            },
                            {
                                name: "Invoice Status",
                            },

                            {
                                name: "Invoice Coins",
                            },

                            {
                                name: "Invoice Amount ",
                            },
                            {
                                name: "Invoice ",
                            },
                            {
                                name: "Transfer",
                            },
                            {
                                name: "Posted Date",
                            },
                        ]}
                        data={requirementsData && requirementsData.map((item, index) => {
                            return [
                                <>
                                    {currerntPage !== 0 ? 10 * currerntPage - 10 + index + 1 : index + 1}
                                </>,
                                <>
                                    {item.recruiter?.firstName + " " + item.recruiter?.lastName} <br />
                                    ({item.recruiter?.companyName})
                                </>,
                                <>
                                    {item.uniqueId}
                                </>,
                                <>
                                    {item.status === "PAID" ? (
                                        `${item?.transactionNumber && item?.transactionNumber}`

                                    ) : "-"}
                                </>,
                                <div style={{ display: 'flex', gap: "5px" }}>
                                    <div className={`status-tag ${getApprovalStatusColor(item.status)}`}>
                                        <i
                                            className={`highlight ${getApprovalStatusColor(item.status)}`}
                                            style={blinkIteration}
                                        ></i>
                                        <p className='status-tag__txt bac-l-stack-xs' style={{ textTransform: 'capitalize' }}>{item.status}</p>
                                    </div>
                                    {item.status === "REJECTED" && (
                                        <Tooltip
                                            title="Reason"
                                            placement="bottom"
                                            aria-label="reason"
                                        >
                                            <MessageIcon className={classes.toolIcon} onClick={() => { setReasonOpen(true); setRejectReason(item.rejectReason) }} />
                                        </Tooltip>
                                    )}
                                </div>,
                                <>{item.redeemValue} </>,
                                item.inrValue,
                                <div style={{ display: 'flex', gap: "5px" }}>
                                    <Tooltip
                                        title="View Invoice"
                                        placement="bottom"
                                        aria-label="view"
                                    >
                                        <RemoveRedEyeIcon
                                            className={classes.toolIcon}
                                            onClick={() => handleModalOpen(item.invoice)}
                                        />
                                    </Tooltip>
                                    <Tooltip
                                        title="Downlaod Invoice"
                                        placement="bottom"
                                        aria-label="downlaod"
                                    >
                                        <a className={classes.messageContent} href={item.invoice} download>

                                            <GetAppIcon className={classes.toolIcon} />
                                        </a>
                                    </Tooltip>
                                </div>,
                                <>
                                    {item.status === "PAID" &&
                                        <Tooltip
                                            title="Paid"
                                            placement="bottom"
                                            aria-label="downlaod"
                                        >
                                            <CheckIcon style={{ color: '#399918' }} />
                                        </Tooltip>
                                    }
                                    {item.status === "REJECTED" &&
                                        <Tooltip
                                            title="Rejected"
                                            placement="bottom"
                                            aria-label="rejected"
                                        >
                                            <CloseIcon style={{ color: '#FF4C4C' }} />
                                        </Tooltip>
                                    }
                                    {item.status === "PENDING" &&
                                        <button className="pay_button" onClick={() => { updateTransactionOpen(item.id) }}>
                                            Pay
                                            <svg className="svgIcon_pay_button" viewBox="0 0 576 512"><path d="M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"></path></svg>
                                        </button>
                                    }
                                </>,
                                moment(item.createdAt).format("DD-MM-YYYY"),
                            ];
                        })}
                    />

                    <Grid container spacing={2} className={classes.pagination}>
                        <TablePagination
                            rowsPerPageOptions={[50]}
                            component="div"
                            count={count}
                            rowsPerPage={10}
                            page={page}
                            onPageChange={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </Grid>


            <Dialog
                aria-labelledby="dialog-title"
                onClose={handleModalClose}
                open={modalOpen}
                fullWidth={true}
                maxWidth="md"
                PaperProps={{
                    style: {
                        width: "100%",
                    },
                }}
            >
                <DialogContent>
                    <Grid container direction="row" spacing={2}>
                        <div className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}>
                            <Typography variant="subtitle2" className={classes.inputRoot}>
                                Invoice
                            </Typography>
                            <div className={classes.pdfModalCloseBtn}>
                                <CloseIcon className={classes.closeBtn} onClick={handleModalClose} />
                            </div>
                        </div>
                        <Grid item xs={12}>
                            {fileExtension === "pdf" ?
                                <CustomPdfView resumeUrl={invoicePDF} />
                                :
                                <div className={classes.iframediv} style={{ marginTop: "40px" }}>
                                    <iframe
                                        src={
                                            "https://docs.google.com/a/umd.edu/viewer?url=" +
                                            invoicePDF +
                                            "&embedded=true"
                                        }
                                        title="File"
                                        width="100%" height="500" sandbox="allow-scripts allow-same-origin"
                                    >
                                    </iframe>
                                    <div className={classes.iframeLogo} >
                                    </div>
                                </div>
                            }
                        </Grid>

                        <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                            <Button variant="contained" size="small" color="secondary" onClick={handleModalClose}>
                                Close
                            </Button>
                        </div>
                    </Grid>
                </DialogContent>
            </Dialog>

            <Dialog
                aria-labelledby="dialog-title"
                open={transferopen}
                width="md"
                PaperProps={{
                    style: {
                        width: "100%",
                    },
                }}
            >
                <DialogContent>
                    <Grid container direction="row" spacing={2}>
                        <div className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}>
                            <Typography variant="subtitle2" className={classes.inputRoot}>
                                Freelancer Invoice
                            </Typography>
                            <div className={classes.pdfModalCloseBtn}>
                                <CloseIcon className={classes.closeBtn} onClick={updateTransactionClose} />
                            </div>
                        </div>
                        <Grid item xs={12}>
                            <div className={classes.iframediv} style={{ marginTop: "45px" }}>

                                {!transactionStatus.paid && !transactionStatus.reject &&

                                    <div style={{ display: 'flex', justifyContent: "center", gap: '10px' }}>
                                        <Button variant="contained" size="small" color="Primary" onClick={() => setTransactionStatus({
                                            paid: true,
                                            reject: false
                                        })}>
                                            Pay
                                        </Button>
                                        <Button variant="contained" size="small" color="secondary" onClick={() => setTransactionStatus({
                                            paid: false,
                                            reject: true
                                        })}>
                                            Reject
                                        </Button>
                                    </div>
                                }
                                {transactionStatus.paid && !transactionStatus.reject &&
                                    <Grid container direction="row" spacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel shrink htmlFor="transactionNumber">
                                                Transaction Number
                                            </InputLabel>
                                            <FormControl className={classes.margin}>
                                                <TextField
                                                    InputProps={{ disableUnderline: true }}
                                                    classes={{ root: classes.customTextField }}
                                                    size="small"
                                                    onChange={(e) => setTransactionPaidNumber(e.target.value)}
                                                    placeholder="Enter Transaction Number"
                                                    id="transactionNumber"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button variant="contained" size="small" color="primary" onClick={approveInvoiceByAdmin}>
                                                Pay
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                                {!transactionStatus.paid && transactionStatus.reject &&
                                    <Grid container direction="row" spacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel shrink htmlFor="reasonForReject">

                                                Reason for Job Change
                                            </InputLabel>
                                            <FormControl className={classes.margin}>
                                                <TextField
                                                    multiline
                                                    maxRows={3}
                                                    InputProps={{ disableUnderline: true }}
                                                    classes={{ root: classes.customTextField }}
                                                    onChange={(e) => setTransactionRejectReason(e.target.value)}
                                                    size="small"
                                                    placeholder="Enter Reason for Reject Payment"
                                                    id="reasonForReject"
                                                />

                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button variant="contained" size="small" color="secondary" onClick={rejectInvoiceByAdmin}>
                                                Reject
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }

                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            <Dialog
                aria-labelledby="dialog-title"
                open={reasonOpen}
                width="md"
                PaperProps={{
                    style: {
                        width: "100%",
                    },
                }}
            >
                <DialogTitle className={classes.digTitle}>
                    <div className={classes.center}>
                        <Typography
                            variant="subtitle2"
                            className={classes.digColor + " " + classes.digCenter}
                            style={{ fontSize: "1.3rem" }}
                        >
                            Reject Reason
                        </Typography>
                        <div className={classes.drawerClose}>
                            <CloseIcon
                                className={classes.digClose}
                                size="14px"
                                onClick={() => { setReasonOpen(false); setRejectReason("") }}
                            />
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle2" style={{ fontSize: "1rem" }}>
                        Your Invoice Was Rejected
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "0.85rem", padding: "15px 0" }}>
                        {rejectReason}
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "0.75rem", fontStyle: "italic" }}>
                        Please resolve your issue and submit the invoice once more.
                    </Typography>
                    <Grid className={classes.sendWhatsapp}>
                        <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={() => { setReasonOpen(false); setRejectReason("") }}
                        >
                            Close
                        </Button>
                    </Grid>
                </DialogContent>
            </Dialog>

            <Backdrop className={classes.backdrop} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

